import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Typography, WithStyles } from "@material-ui/core";
import { styles } from "./StatsFilter.styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { getStatFilterDef, IFilterSection, IStatsFilterOptionType } from "./StatsFilter";
import Grid from "@material-ui/core/Grid/Grid";

export interface IStatsFilterOptionProps extends WithStyles<typeof styles> {
    filter: IFilterSection;
    selectedValues: string[];
    onChange: (name: IStatsFilterOptionType, values: string[]) => void;
}

const StatsFilterOptionPure: React.FunctionComponent<IStatsFilterOptionProps> = ({
    classes,
    filter,
    selectedValues,
    onChange
}: IStatsFilterOptionProps) => {
    return (
        <Grid container spacing={3}>
            <Grid xs={filter.gridSize} item>
                <Typography variant="h6">{filter.title}</Typography>
                <div className={classes.sectionInput}>
                    <ToggleButtonGroup
                        value={selectedValues}
                        onChange={(e, newValues) => onChange(filter.name, newValues)}
                        aria-label="text formatting"
                        className={classes.buttonGroup}
                    >
                        {getStatFilterDef(filter.name)?.options.map(option => (
                            <ToggleButton
                                key={option}
                                value={option}
                                aria-label="bold"
                                className={classes.toggleButton}
                            >
                                {option}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </div>
            </Grid>
        </Grid>
    );
};

export const StatsFilterOption = withStyles(styles)(StatsFilterOptionPure);
